import {ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AclConstants } from '../../aclOperationConstants';
import { AclClassConstants } from '../../aclClassConstants';
import { LoginService } from '../../login/login.service';
import {MatTableDataSource} from '@angular/material';
import {Subscription} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {DomSanitizer} from '@angular/platform-browser';
import { AbstractBaseListComponent } from '../../../components/base/abstract-base-list-component';
import { AclList } from './model/acl-list';
import { AclService } from '../service/acl.service';
import { SearchService } from '../../../services/search.service';
import { IBaseService } from '../../../services/ibase-service';
import { SearchControlTypeEnum, SearchDataTypeEnum } from '../../../core/enum/searchType.enum';
import { OrderingData } from '../../../core/modal/ordering-data';
import { PaginationData } from '../../../core/modal/pagination-data';
import { TableKeyEnum } from '../../../core/enum/table-key.enum';


@Component({
  selector: 'app-acl',
  templateUrl: './acl.component.html',
  styleUrls: ['./acl.component.scss']
})
export class AclComponent  extends AbstractBaseListComponent<AclList> implements OnInit, OnDestroy {
  dataGrid: AclList[] = [];
  tableKeyEnum = TableKeyEnum;
  // config for neo-table
  dataSource = new MatTableDataSource([]);
  subscriptions: Subscription[] = [];
  allColumns:any=[];
  public entity: AclList = new AclList();
  public entity_id: any = null;
  form: FormGroup;

  @ViewChild('actionBtn', { static: false }) actionBtnRef: TemplateRef<any>;
  @ViewChild('aclName', { static: false }) aclRolReff: TemplateRef<any>;
  @ViewChild('status', { static: false }) statusRef: TemplateRef<any>;
  
  AclClassConstants = AclClassConstants;
  AclConstants = AclConstants;
  public loginService: LoginService;

  people: any[];
  peopleTemp: any[];
  neoTableSetting:any={};
  searchSettings = [];


  constructor(private entityService : AclService,
              private route: ActivatedRoute,
              private router: Router,
              private toastrService: ToastrService,
              private sanitizer: DomSanitizer,
              private cdRef: ChangeDetectorRef,
              private searchService: SearchService,
              loginService: LoginService
              ) {
    super(toastrService, searchService);
    this.loginService = loginService;
  }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'actionCol') {
        col.customControls = [this.actionBtnRef];
      }
      if (col.colKey == 'rolename') {
        col.customControls = [this.aclRolReff];
      }
      if (col.colKey == 'status') {
        col.customControls = [this.statusRef];
      }

    });
  }

  ngOnInit() {
    this.setDefaultPageSize(this.tableKeyEnum.ACL_LIST)
    this.init();

    const filterSubscription = this.searchService.getFilterOptions().subscribe((obj) => {
      // if (obj && obj.filters) {
      this.applyFilter(obj);
      // }else
    });

    this.subscriptions.push(filterSubscription);
  }
  getService(): IBaseService<AclList> {
    return this.entityService;
  }

  getTableColumn() {
    let self = this;

    this.allColumns = [
      {
        colKey: 'index',
        default: 'ID',
        rowKey: 'id',
        width: '1%',
        isFilterAllow: false,
        isNumber: true,
      },
      {
        colKey: 'rolename',
        default: 'Role Name',
        rowKey: 'rolename',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'status',
        default: 'Status',
        rowKey: 'status',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'updatedate',
        default: 'Last Modified',
        rowKey: 'updatedate',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
        //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
    this.allColumns.forEach(element => {
      element.isFilterAllow = false;
    });
    return this.allColumns ? this.allColumns : [];
  }

  getTableSetting() {
    this.neoTableSetting = {
      showAdvanceSearch: false,
      showFooter: false,
      showPagination: true,
      tableId: this.tableKeyEnum.ACL_LIST,
      perPage: this.paginationData.rowsPerPage,
      pageNumber:this.paginationData.pageNumber - 1,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      sort: true,
      serverSideSortPagination: true,
      pageTotalLength: 0,
      serverSideFilter: true,
      //defaultSortCol: '',
      //defaultSortDirection: 'desc',
      // enableMultiDelete: true,
      columns: this.getTableColumn(),
      deleteMsgBoxTitle: 'Are you sure to delete this Acl Role ?',
      deleteMsgBoxDetail: 'Acl Role Name :${rolename} ',
    };
    return this.neoTableSetting;
  }

  getTableSearchSetting() {
    this.searchSettings = [
      {
        display_field: 'Role Name',
        value_field: 'rolename',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
      {
        display_field: 'Status',
        value_field: 'status',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
    ];
    return this.searchSettings;
  }

  refreshDataSource(data) {
    if (data) {
      this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    }
  }
  onSortChange(event) {
    let orderingData = new OrderingData();
    orderingData = event;
    this.onOrderingChange(orderingData);
  }

  onPageChange(event) {
    let paginationData = new PaginationData();
    paginationData = event;
    this.onPaginationChange(paginationData);
  }
  // onEditClick(event) {

  //   this.setUpdateValueInForm(event.RowData);
  // }

  // onDeleteClick(event) {
  //   if (event.deletClicked) {
  //     this.delete(event.RowData);
  //   }
  // }

  onEditClick(event) {
    this.setUpdateValueInForm(event);
  }

  onDeleteClick(event) {
     if (event) {
       this.commonDeleteMsgBox(this.getTableSetting(),event,this.afterDeleteConfirm.bind(this));
     }
  }

  afterDeleteConfirm(objEvent) {
    if (objEvent.deleteClicked) {
      this.delete(objEvent.event);
    }
  }

  setList(list: Array<AclList>) {
    ////console.log("LIST::",list);
    this.dataGrid = list;
    this.neoTableSetting.pageTotalLength = this.totalRecords;
    this.refreshDataSource(this.dataGrid);
  }

  applyFilter(filterObj) {
    let filteredDataForGrid = JSON.parse(JSON.stringify(this.dataGrid));
    let filters = filterObj && filterObj.filters ? JSON.parse(JSON.stringify(filterObj.filters)) : null;

    if (this.neoTableSetting.serverSideFilter) {
      this.onFilterChange(filters);
    } else {
      if (!filters) {
        filteredDataForGrid = this.searchService.getFilteredData(filters,this.dataGrid);
        this.refreshDataSource(filteredDataForGrid);
      }
    }
  }
  /*
    onNeoFilterChange(filterObj) {
      let searchData = new SearchData();
      searchData = filterObj;
      if (searchData.filterColumn) {
        let serverFilterObj = this.searchService.manageServerFilterObj([searchData]);
        ////console.log('Server final filtre obj', serverFilterObj);
      }
    }*/

  onAddClick() {
    this.router.navigate(['/hr/add-role']);
  }

  setUpdateValueInForm(rowData) {
    this.router.navigate(['/hr/add-role',rowData.id]);
  }

  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.subscriptions.map((subscription) => {
        subscription.unsubscribe();
      });
    }
  }
}
